import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import logo from "../../images/BIGLOGO.png";

import MainFeature from "components/features/TwoColWithButton.js";

import map from "../../images/Toronto-Map-Black-Line-3-1024x637.jpg";
import CheckfrontBookingWidget from './CheckfrontBookingWidget.js';

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;

const Content = tw.div`mt-16`;

const imageCss = tw`rounded-4xl`;

const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const Subheading = tw.span`tracking-wider text-sm font-medium`;

const Card = styled.div(props => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row"
]);
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

const Heading = styled.h1`
  ${tw`text-3xl font-black text-gray-100 leading-snug -mt-24 sm:mt-0`}
  item-align: center !important;
  span {
    ${tw`inline-block mt-2`}
  }
`;

export default () => {
  const cards = [
  ];

  return (
    <Container>
              <div id="target-section">
          <CheckfrontBookingWidget/>
        </div>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Get to the Islands faster with Toronto Harbour Water Taxi!</HeadingTitle>
          <img src={logo} style={{ width: "50%", height: "50%" }} alt="logo" />
        </HeadingInfoContainer>
        <Content>
        <MainFeature
        subheading={<Subheading>Established Since 1995</Subheading>}
        heading={
          <>
            We've been moving for
            <wbr /> <HighlightedText>over 30 years.</HighlightedText>
          </>
        }
        description={
          <Description>
            Welcome to Toronto’s Longest Running Water Taxi! Since 1995, our fleet of yellow boats have pioneered the concept of fast, fun, and efficient transportation throughout the Toronto Harbour. Our professional and fun services shuttle island residents, tourists, and locals to our beloved Toronto Islands.
            <br />
            <br />
            Come find us at York Street under our yellow umbrella and take a ride! Follow @towatertaxi for service updates.
          </Description>
        }
        buttonRounded={true}
        textOnLeft={false}
        primaryButtonText="Instagram"
        primaryButtonUrl="https://www.instagram.com/towatertaxi"
        imageSrc={map}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />

          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
